<div class="marketing-label" *ngIf="labels$ | async as labels">
  <span *ngFor="let label of labels" [ngClass]="'marketing-label-' + label"></span>
</div>
